// extracted by mini-css-extract-plugin
export default {"sectionTitle":"u8IKvl","skeletonGroup":"ajyMwl","skeleton":"UhbkXK","mobileCtaSkeleton":"Zn0pJb","tile":"emtT5P","bngSkeletonFadeIn":"_3aV_2B","mobileCtaSkeletonGroup":"igWEBv"};